import { Component, OnDestroy, OnInit } from '@angular/core';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  extractDefaultStoreId,
  HxAuthService,
  HxStoreProductService,
  HxUiLabelPipe,
  StoreBasicModel,
  StoreFullModel,
  StoreProductModel,
  toRouterQueryParams
} from 'hx-services';
import { HxLoaderComponent, HxProductCategorySelectComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { StoreProductsNewComponent } from '../store-products-new/store-products-new.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-store-products-list',
    templateUrl: './store-products-list.component.html',
    styleUrls: ['./store-products-list.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxProductCategorySelectComponent, StoreProductsNewComponent, NgIf, NgFor, NgClass, HxLoaderComponent, NgbPagination, TranslocoPipe, HxUiLabelPipe]
})
export class StoreProductsListComponent implements OnInit, OnDestroy {
  list: StoreProductModel[] = [];
  isLoading = {
    list: false,
  };
  pagination = {allItemCount: 0};
  stores: StoreFullModel[] = [];
  params: {
    page?: number;
    limit?: number;
    storeId?: number;
    query?: string;
    categoryId?: number;
  } = {page: 1, limit: 20};
  storeProductId: number;
  brandId: number;
  private sub: Subscription;

  constructor(
    private storeProductService: HxStoreProductService,
    private toastr: HcToastrService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private auth: HxAuthService,
  ) {
  }

  ngOnInit() {
    this.getDefaultStore();
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      const asNumberFn = (name: string, def?: number) => paramMap.get(name) ? Number(paramMap.get(name)) : def;
      this.params.categoryId = asNumberFn('categoryId');
      this.params.storeId = asNumberFn('storeId') ?? extractDefaultStoreId();
      this.params.query = paramMap.get('query');
      if (this.params.storeId) {
        this.loadList();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  resetFilter() {
    this.pagination.allItemCount = 0;
    this.params.query = null;
    this.params.page = 1;
    this.params.limit = 20;
    this.params.categoryId = undefined;
    this.navigateUrl();
  }

  onStoreChanged(store?: StoreBasicModel | StoreBasicModel[]) {
    if (Array.isArray(store)) {
      return;
    }
    this.brandId = store?.brandId;
    this.applyFilters();
  }

  pageChanged(page: number) {
    this.params.page = page;
    this.navigateUrl();
  }

  applyFilters() {
    this.pageChanged(1);
  }

  updater(event) {
    this.storeProductId = null;
    if (event) {
      this.loadList();
    }
  }

  updateItem(sp: StoreProductModel) {
    this.storeProductId = sp.id;
  }

  private async getDefaultStore() {
    this.stores = await this.auth.getComponentStores();
    if (this.stores.length) {
      this.stores = this.stores.sort((a, b) => a.id - b.id);
      const selectedStore = this.stores[0];
      this.params.storeId = selectedStore?.id;
      this.brandId = selectedStore?.brandId;
      this.navigateUrl();
    }
  }

  private loadList() {
    this.list = [];
    this.isLoading.list = true;
    this.storeProductService.getStoreProductList(this.params).subscribe(result => {
      this.list = result.list || [];
      this.isLoading.list = false;
      this.pagination.allItemCount = result.count;
    }, () => {
      this.isLoading.list = false;
    });
  }

  private navigateUrl() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }
}
